import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { IBranch } from 'app/shared/Domains/branch';
import { ICompany } from 'app/shared/Domains/company';
import { IUser } from 'app/shared/Domains/IUser';
import { AppServiceManager } from 'common/services/appServiceManager';
import { Configuration } from 'config/config';
import { UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';
import globalVariable from "../../../../globalVariable/globalVariable.json";
import { BreadcrumbService } from 'app/breadcrumb.service';
import { ConfirmationService } from "primeng/api";
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
  selector: 'app-register-branch-from-company',
  templateUrl: './register-branch-from-company.component.html',
  host: { "(window:keyup)": "hotkeys($event)", "(window:click)": "hotClick($event)" },
  styleUrls: ['./register-branch-from-company.component.css']
})
export class RegisterBranchFromCompanyComponent implements OnInit {
  errorExempleNumber: any;
  company: ICompany;
  branch: IBranch;
  branchForm: UntypedFormGroup;
  userForm: UntypedFormGroup;
  isCompany: boolean = true;
  indextab: number = 0;
  user: IUser;
  enterSteps: any[];
  currentStep: any = 0;
  dialogVisibility: boolean;
  userdomain: any;

  constructor(
    private LanguageService: LanguageService,
    private navRoute: Router,
    private _http: HttpClient,
    public config: Configuration,
    private appServiceManager: AppServiceManager,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    private confirmationService: ConfirmationService,

  ) {
    this.breadcrumbService.setItems([
      { label: 'Branch Management' },
      { label: 'All Branches', routerLink: '/settings/branches' },
      { label: 'Register Branch' }
    ]);
  }

  get branchname() { return this.branchForm.get('branchname'); }
  get domainname() { return this.branchForm.get('domainname'); }
  get whatsapp() { return this.branchForm.get('whatsapp'); }
  get registrationwhatsapp() { return this.branchForm.get('registrationwhatsapp'); }
  get visitorwhatsapp() { return this.branchForm.get('visitorwhatsapp'); }
  get feewhatsapp() { return this.branchForm.get('feewhatsapp'); }
  get branchaddress() { return this.branchForm.get('branchaddress'); }
  get branchphone() { return this.branchForm.get('branchphone'); }
  get branchcontactPerson() { return this.branchForm.get('branchcontactPerson'); }
  get branchcontactPersonEmail() { return this.branchForm.get('branchcontactPersonEmail'); }
  get gymPackage() { return this.branchForm.get('gymPackage'); }

  get fullname() { return this.userForm.get('fullname'); }
  get username() { return this.userForm.get('username'); }
  get useremail() { return this.userForm.get('useremail'); }
  get password() { return this.userForm.get('password'); }

	setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("RegisterBranchFromCompanyComponent", label);
  }
  ngOnInit(): void {
    this.InitObjects();
  }

  ngAfterViewInit() {
    document.getElementById("branchname").focus();
  }

  InitObjects() {
    this.errorExempleNumber = globalVariable.exampledata.pakNumber;
    this.company = new ICompany();
    this.branch = new IBranch();
    this.user = new IUser();
    this.validationBranchForm();
    this.validationUserForm();

    if (this.indextab == 0) {
      this.enterSteps = [
        "branchname",
        "domainname",
        "whatsapp",
        "registrationwhatsapp",
        "visitorwhatsapp",
        "feewhatsapp",
        "branchaddress",
        "branchphone",
        "branchcontactPerson",
        "branchcontactPersonEmail",
        "branchNextButton",
        "gymPackage",
      ];
    } else if (this.indextab == 1) {
      this.enterSteps = [
        "fullname",
        "username",
        "useremail",
        "password",
        "registerButton",
      ];
    }
  }

  validationBranchForm() {
    const regexNumber = /\-?\d*\.?\d{1,2}/;
    this.branchForm = new UntypedFormGroup({
      'branchname': new UntypedFormControl(this.branch.name, [
        Validators.required,
        Validators.minLength(4),
      ]),
      'domainname': new UntypedFormControl(this.branch.domain, [
        Validators.required,
        Validators.minLength(3),
      ]),
      'branchaddress': new UntypedFormControl(this.branch.address, [
      ]),
      'branchphone': new UntypedFormControl(this.branch.phone, [
        Validators.pattern(/^(03)[0-9]{9}$/)
      ]),
      'whatsapp': new UntypedFormControl(this.branch.whatsapp, [
        Validators.pattern(/^(03)[0-9]{9}$/)
      ]),
      'registrationwhatsapp': new UntypedFormControl(this.branch.registrationWhatsapp, [
        Validators.pattern(/^(03)[0-9]{9}$/)
      ]),
      'visitorwhatsapp': new UntypedFormControl(this.branch.visitorWhatsapp, [
        Validators.pattern(/^(03)[0-9]{9}$/)
      ]),
      'feewhatsapp': new UntypedFormControl(this.branch.feeWhatsapp, [
        Validators.pattern(/^(03)[0-9]{9}$/)
      ]),
      'gymPackage': new UntypedFormControl(this.branch.gymPackage || 'standard', [ // Set default to 'standard'
        Validators.required,
      ]),
      'branchcontactPerson': new UntypedFormControl(this.branch.contactPerson, [
      ]),
      'branchcontactPersonEmail': new UntypedFormControl(this.branch.contactPersonEmail, [
        Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
      ]),
    });
  }

  validationUserForm() {
    const regexNumber = /\-?\d*\.?\d{1,2}/;
    this.userForm = new UntypedFormGroup({
      'fullname': new UntypedFormControl(this.user.name, [
        Validators.required,
        Validators.minLength(4),
      ]),
      'useremail': new UntypedFormControl(this.user.email, [
        Validators.required,
        Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
      ]),
      'username': new UntypedFormControl(this.user.username, [
        Validators.required,
      ]),
      'password': new UntypedFormControl(this.user.password, [
        Validators.required
      ])
    });
  }

  isNullOrUndefined(value: any) {
    return value === null || value === undefined;
  }

  nextform(form: any) {
    if (form.valid) {
    if (this.indextab == 0) {
      this.userdomain = this.branchForm.controls['domainname'].value;
      this.indextab = 1;
      this.currentStep = -1;
      this.enterSteps = [
        "username",
        "useremail",
        "password",
        "registerButton",
      ];
      this.userForm.setValue({
        fullname: '',
        useremail: !this.isNullOrUndefined(this.branchForm.controls['branchcontactPersonEmail']) ? this.branchForm.controls['branchcontactPersonEmail'].value : ' ',
        username: !this.isNullOrUndefined(this.branchForm.controls['branchcontactPersonEmail']) ? this.branchForm.controls['branchcontactPersonEmail'].value.split('@')[0] : '',
        password: '',
      })
      document.getElementById("username").focus();
    }
  }
  else {
      //  // Form validation error handling
          Object.keys(form.controls).forEach(controlName => {
          const control = form.controls[controlName];
          control.markAsTouched(); // Mark the control as touched to display the validation error messages
      });
  }
  }

  setBranchValues() {
    this.branch.name = !this.isNullOrUndefined(this.branchForm.controls['branchname']) ? this.branchForm.controls['branchname'].value : '';
    this.branch.address = !this.isNullOrUndefined(this.branchForm.controls['branchaddress']) ? this.branchForm.controls['branchaddress'].value : '';
    this.branch.phone = !this.isNullOrUndefined(this.branchForm.controls['branchphone']) ? this.branchForm.controls['branchphone'].value : '';
    this.branch.contactPerson = !this.isNullOrUndefined(this.branchForm.controls['branchcontactPerson']) ? this.branchForm.controls['branchcontactPerson'].value : '';
    this.branch.contactPersonEmail = !this.isNullOrUndefined(this.branchForm.controls['branchcontactPersonEmail']) ? this.branchForm.controls['branchcontactPersonEmail'].value : '';
    this.branch.domain = !this.isNullOrUndefined(this.branchForm.controls['domainname']) ? this.branchForm.controls['domainname'].value : '';
    this.branch.whatsapp = !this.isNullOrUndefined(this.branchForm.controls['whatsapp']) ? this.branchForm.controls['whatsapp'].value : '';
    this.branch.visitorWhatsapp = !this.isNullOrUndefined(this.branchForm.controls['visitorwhatsapp']) ? this.branchForm.controls['visitorwhatsapp'].value : '';
    this.branch.registrationWhatsapp = !this.isNullOrUndefined(this.branchForm.controls['registrationwhatsapp']) ? this.branchForm.controls['registrationwhatsapp'].value : '';
    this.branch.feeWhatsapp = !this.isNullOrUndefined(this.branchForm.controls['feewhatsapp']) ? this.branchForm.controls['feewhatsapp'].value : '';
    this.branch.gymPackage = !this.isNullOrUndefined(this.branchForm.controls['gymPackage']) ? this.branchForm.controls['gymPackage'].value : 'standard';
  }

  setUserValues() {
    this.user.name = this.userForm.controls['fullname'].value;
    this.user.username = this.userForm.controls['username'].value;
    // this.user.email = this.userForm.controls['useremail'].value;
    this.user.email = `${this.user.username}@${this.userdomain}`;
    this.user.password = this.userForm.controls['password'].value;
    this.user.profile = 'assets/layout/images/avatarBoyImage.png';
  }

  registerBranch(form: any) {
    if (form.valid) {
    this.setBranchValues();
    this.setUserValues();
    var obj = {
      branch: this.branch,
      user: this.user
    }
    this.confirmationService.confirm({
      message: "Are you sure you want to register branch ?",
      accept: () => {
    let company = JSON.parse(localStorage.getItem('currentCompany'));
    this.appServiceManager.put("branches/registerBranch/" + company._id, obj).subscribe((res: any) => {
      if (res) {
        this.appServiceManager.post("heartbeat", res[0]).subscribe((heartbeatresponse:any) => {
          if(heartbeatresponse){
            console.log("HearBeat Succefully Added");
          }else{
            console.log("HearBeat Unsuccefull");
          }
        });
        this.messageService.clear();
        this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Branch and User Successfully Registered' });
        this.navRoute.navigateByUrl('settings/branches');
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }

    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
    }
  });
}
    else {
        //  // Form validation error handling
        Object.keys(form.controls).forEach(controlName => {
            const control = form.controls[controlName];
            control.markAsTouched(); // Mark the control as touched to display the validation error messages
        });
    }

  }

  hotkeys($event) {
    if ($event.keyCode == 13) {
      var nextStep = this.enterSteps.length - 1 > this.currentStep ? this.currentStep + 1 : 0;
      var nextId = this.enterSteps[nextStep];
      let ele: any = document.getElementById(nextId)
      ele.focus();
      this.currentStep = nextStep;
    }
  }

  hotClick($event) {
    let currentClickLocation = $event.target.id;
    let indexOfClickField = this.enterSteps.indexOf(currentClickLocation);
    if (indexOfClickField !== -1) {
      this.currentStep = indexOfClickField;
    }
    else {
      this.currentStep = this.currentStep;
    }
  }

}
